import TomSelect from 'tom-select/base';

const SELECT_SELECTOR = '[data-searchable-select]';
const STATE_SELECTOR = '[data-filter-state]';

// Tom Select's own default. Handing it a falsy controlInput leaves the text
// input out of the control, which makes the select click-only.
const SEARCH_INPUT = '<input type="text" autocomplete="off" size="1" />';

/**
 * The filters narrow one another, so the server recalculates every option list
 * on each change. Tom Select owns its markup and therefore sits behind
 * wire:ignore, which means those fresh lists cannot reach it through the
 * morph -- they arrive in the state element instead.
 */
function stateOf(root) {
    const node = root.querySelector(STATE_SELECTOR);

    if (! node) {
        return null;
    }

    try {
        return JSON.parse(node.textContent);
    } catch (error) {
        return null;
    }
}

function emptyLabel(select) {
    return select.dataset.emptyLabel || '';
}

function isSearchable(select) {
    return select.hasAttribute('data-search');
}

function build(select) {
    if (select.tomselect) {
        return;
    }

    new TomSelect(select, {
        create: false,
        allowEmptyOption: true,
        maxOptions: null,
        placeholder: emptyLabel(select),
        controlInput: isSearchable(select) ? SEARCH_INPUT : null,

        // Holding the empty option as a selected item marks the control
        // "has-items", which hides the text box behind the label already
        // standing there. Let the placeholder carry it instead.
        onChange(value) {
            if (value === '' && isSearchable(select)) {
                this.clear(true);
            }
        },
    });
}

function refresh(select, state) {
    const control = select.tomselect;
    const field = select.dataset.searchableSelect;

    if (! control || ! field) {
        return;
    }

    // Value and label differ for the season, which reads as "Zomer" but is
    // stored as "zomer", so the state carries both.
    const options = (state.options || {})[field] || [];
    const value = String((state.input || {})[field] ?? '');

    control.clearOptions(() => false);
    control.addOption({ value: '', text: emptyLabel(select) });

    options.forEach((option) => control.addOption({
        value: option.value,
        text: option.label,
    }));

    control.refreshOptions(false);

    // Silent, or writing the value back would bounce another round trip.
    if (value === '' && isSearchable(select)) {
        control.clear(true);
    } else {
        control.setValue(value, true);
    }
}

function mount(root) {
    const state = stateOf(root);

    root.querySelectorAll(SELECT_SELECTOR).forEach((select) => {
        build(select);

        if (state) {
            refresh(select, state);
        }
    });
}

document.addEventListener('livewire:load', () => {
    mount(document);

    window.Livewire.hook('message.processed', (message, component) => mount(component.el));
});
